<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机器人设置</el-breadcrumb-item>
        <el-breadcrumb-item>机器人日志</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <!-- 第一行筛选框 -->
        <el-row :gutter="20">
                <!-- 机器名查询 -->
                <!-- <el-col :span="5" >
                    <span>机器编号:</span>
                    <el-input placeholder="请输入编号" v-model="robotlog.robotNo" class="m-l-30 ell-input" ></el-input>
                </el-col> -->
               <el-col :span="6">
                        <el-date-picker v-model="robotlog.createTimeStr"  type="date"  value-format="yyyy-MM-dd"  placeholder="日志日期" class="m-l-30 ell-input"> </el-date-picker>
               </el-col>
               
        </el-row>
        <!-- 第二行筛选框 -->
        <el-row :gutter="20" >
            <!-- 创建时间 -->
            <el-col align="middle" >
                <el-button type="primary" @click="searchRobotlog()">查询</el-button>
                <el-button type="info" @click="clearParams()">重置</el-button>
                <el-button type="primary" @click="returnMissionPlanning()">返回</el-button>
            </el-col>   
        </el-row>
        <!-- 用户列表区域 -->
        <el-table :data="robotlogList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="机器人编号" prop="robotNo" width="270"></el-table-column>
            <el-table-column label="日志地址"  width="250">
                 <template   slot-scope="scope">
                   <!-- <a :href="path+scope.row.logUrl" target="_blank" class="buttonText">下载日志文件</a> -->
                   <el-button type="success" size="mini" @click="uploadLog(scope.row)">日志文件上传</el-button>
                   <!-- <el-button type="success" size="mini" @click="uploadMasterLog(scope.row)">自主日志文件下载</el-button> -->
                </template>
            </el-table-column>
            <el-table-column label="文件路径"  width="150">
                 <template   slot-scope="scope">
                    <a :href="path+scope.row.logUrl" target="_blank" class="buttonText"  v-if="scope.row.logUrl!='' && scope.row.logUrl!=null">日志文件下载</a>
                </template>
            </el-table-column>
            <el-table-column label="日志文件日期" prop="createTimeStr" width="180"  ></el-table-column>
        </el-table>
        <!-- 上传日志进度条  -->
        <el-dialog :title="title"  :visible.sync="dialogProgressVisible" class="taskdialog" @close="progressDialogClose"  >
            <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
        </el-dialog>
         <!-- 分页区间 -->
        <el-pagination   @current-change="handleCurrentChange"  :current-page.sync="robotlog.num"  
                :page-size="10"  layout="total, prev, pager, next"  :total="total">
        </el-pagination>
    </el-card >
  </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
  name: 'machine',
  data(){
      return {
          robotlog :{
              createTimeStr:'',
              robotNo:'',
              num : 1,
              status:''
          },
          total:0,
          path:'',
          logType:'',
          robotlogList:[],
          topic:'',
          dialogProgressVisible:false,
          percentage:10,
          timer:'',
          robotUrl:'',
          createTimeStr:'',
          title:"机器人正在上传中......."
      }
  },
  computed: mapState([
    // 映射 this.count 为 store.state.count
    'mqttClient'
   ]),
   //生命周期函数
  created(){
    this.connectMqtt()
    //this.init();
  },
  beforeRouteLeave(to, form, next) {
        if(this.mqttClient!=='' && this.mqttClient!==null){
            this.unsubscribe()
        } 
        next()
  },
  mounted(){
    this.$store.dispatch("mqttServer");
  },
  methods:{
        connectMqtt(){
            var that=this;
            if(this.mqttClient==null){
                //启动vuex初始化方法
                this.$store.dispatch('mqttServer')
                setTimeout(function() {
                    that.init()	
                }, 5000); // 定时时间
            }else{
                that.init()	
            } 
        },
        init(){
            this.searchRobotlog()
            window.sessionStorage.setItem("robotLogFlag",this.$route.query.pageFlag)
            this.robotlog.robotNo=this.$route.query.robotNo;
            this.robotlog.status=this.$route.query.status;
            var topic="/Unione/CommandReply/#"
            this.topic=topic;
            try {
                this.mqttClient.subscribe(topic, { qos: 0 }, (error) => {
                        window.sessionStorage.setItem("subscribe",0)
                        console.log('连接成功'+topic)
                        if (!error) {
                        console.log('订阅成功')
                        } else {
                        console.log('订阅失败')
                        }
                })
            } catch (e) {
                var subscribe=window.sessionStorage.getItem('subscribe')
                if(subscribe*1===10){
                    this.$message.error("网络差,退出重新登录!");
                    return this.$router.push('/login') 

                }else{
                    window.sessionStorage.setItem("subscribe",1)
                    this.$store.dispatch('mqttServer')
                    location.reload()
                    return 
                }
                
            }
            let that=this
            // 接收消息处理
            this.mqttClient.on('message', (tcp, message) => {
                let Topic =tcp
                if(!Topic.endsWith(that.robotlog.robotNo)){
                    return
                }
                var data =JSON.parse(message)
                if(data.code!=="0"){
                     return
                }
                //日志上传
                if(that.dialogProgressVisible &&  (data.type=='2' || data.type=='12' ) ){    
                    if(that.logType==="1"){
                        that.title="正在拼命下载中......"
                        if(data.fileType!=undefined){
                            var robotLogUrl="/source/log/"+data.detail.replaceAll('-', '')+"/"+that.robotlog.robotNo+"/"+that.logType+"/"+data.detail+".zip"
                        }else{
                            //拼接资源路径
                            var robotLogUrl="/source/log/"+data.detail.replaceAll('-', '')+"/"+that.robotlog.robotNo+"/"+that.logType+"/"+data.detail+".log"
                        }
                        
                    }  
                    if(that.logType==="2"){
                        //拼接资源路径
                        var robotLogUrl="/source/log/"+data.detail.replaceAll('-', '')+"/"+that.robotlog.robotNo+"/"+that.logType+"/"+data.detail+".zip"
                    } 
                    var t 
                    clearTimeout(t)
                    if(data.fileType!=undefined){
                        t = setTimeout(function() { 
                            //延迟1s关闭对话框,下载文件
                            setTimeout(function() {
                                    //that.progressDialogClose()
                                    that.downloadLog(robotLogUrl)
                            },1000)
                    },3000)
                    }else{
                        t = setTimeout(function() {
                            that.percentage=100
                            clearInterval(that.timer);
                            //延迟1s关闭对话框,下载文件
                            setTimeout(function() {
                                    that.progressDialogClose()
                                    that.downloadLog(robotLogUrl)
                            },1000)
                    },3000)
                    }
                 
                }
            })
        },
        unsubscribe: function() {  
            this.mqttClient.unsubscribe(  
                    this.topic, err => {  
                    console.log(err || '取消订阅成功');  
                }  
            );  
        }, 
        uploadLog(obj){
            this.robotUrl=obj.logUrl
            this.logType="1";
            this.createTimeStr=obj.createTimeStr
            if(this.robotlog.status==0){  
                this.downloadLog(obj.logUrl)
            }else{
                let that=this
                this.$http.get('robot/uploadLog',{params :{ robotNo :  this.robotlog.robotNo, date: obj.createTimeStr, type:"2" }}) .then(response => {
                    if (response.data.code === 200) {                          
                            that.dialogProgressVisible=true
                            that.percentage=0;
                            that.timer = setInterval(() => {
                                if(that.percentage > 100){
                                    that.$message.error("上传超时!");
                                    that.progressDialogClose()
                                    window.location.reload();
                                    return;
                                }else{
                                    that.percentage=that.percentage+1 
                                }  
                            }, 1000);
                    }
                    if(response.data.code !== 200){
                        this.dialogProgressVisible=false
                        this.percentage=10
                        that.downloadLog(obj.logUrl)
                    }
                })
            }
        },
        uploadMasterLog(obj){
            this.robotUrl=obj.logUrl
            this.logType="2";
            this.createTimeStr=obj.createTimeStr
            if(this.robotlog.status==0){  
                this.downloadLog(obj.masterLogUrl)
            }else{
                let that=this
                this.$http.get('robot/uploadLog',{params :{ robotNo :  this.robotlog.robotNo, date: obj.createTimeStr , type:"12" }}) .then(response => {
                    if (response.data.code === 200) {                          
                            that.dialogProgressVisible=true
                            let timeOut=0
                            that.timer = setInterval(() => {
                                if(timeOut > 13){
                                    //that.$message.error("上传超时!");
                                    that.dialogProgressVisible=false
                                    clearInterval(that.timer);
                                    that.downloadLog(obj.masterLogUrl)
                                }
                                if(that.percentage < 90){
                                    that.percentage=that.percentage+10
                                }      
                                timeOut=timeOut+1      
                            }, 1000);
                    }
                    if (response.data.code !== 200){
                        this.dialogProgressVisible=false
                        this.percentage=10
                        that.downloadLog(obj.logUrl)
                    }
                })
            }
        },
        downloadLog(url){
                if(url===undefined || url==="" || url===null){
                    return this.$message.error("未查询到文件!");
                }
                url=url+"?a="+(new Date().getTime());
                let that =this;
                if(that.logType=='1'){
                    var fileUrl=window.location.origin+url
                    this.$http({url:fileUrl,method: 'GET',responseType: "blob"}).then(res => {
                            
                            var baseUrl=res.config.url
                            if(baseUrl!=undefined){
                                var indx=baseUrl.indexOf("?")
                                baseUrl=baseUrl.substring(indx-14, indx)
                            }else{
                                baseUrl=that.createTimeStr+".log"
                            }
                            var blob=new Blob([res.data])
                            let url = window.URL.createObjectURL(blob);
                            let link = document.createElement("a");
                            link.style.display = "none";
                            link.href = url
                            link.download = baseUrl // 文件重命名，若无需重命名，将该行删去
                            link.click()
                            that.progressDialogClose()
                            URL.revokeObjectURL(url) // 释放内存
                    }).catch(res => {
                        that.createTimeStr=''
                        return this.$message.error("未查询到文件!");
                    })
                }else if(that.logType=='2'){
                    const url2 = url.replace(/\\/g, '/');
                    const xhr = new XMLHttpRequest();
                    xhr.open('GET', url2, true);
                    xhr.responseType = 'blob';
                    //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
                    // 为了避免大文件影响用户体验，建议加loading
                    xhr.onload = () => {
                        if (xhr.status === 200) {
                            // 获取文件blob数据并保存
                            that.saveAs(xhr.response, that.createTimeStr+".zip");
                        }
                    };
                    xhr.send();
                }
        },
        saveAs(data, name) {
            const urlObject = window.URL || window.webkitURL || window;
            const export_blob = new Blob([data]);
            //createElementNS() 方法可创建带有指定命名空间的元素节点。
            //此方法可返回一个 Element 对象。
            const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
            save_link.href = urlObject.createObjectURL(export_blob);
            save_link.download = name;
            save_link.click();
        },
        //关闭进度框
        progressDialogClose(){
            this.dialogProgressVisible=false
            this.percentage=10
            clearInterval(this.timer);
        },
        //返回上一页
        returnMissionPlanning(){
            var robotLogFlag=window.sessionStorage.getItem('robotLogFlag')
            if(robotLogFlag==="1"){
                this.$router.replace({path: '/missionPlanning'})
            }
            if(robotLogFlag==="2"){
               this.$router.replace({path: '/robotManage'+'?id='+this.$route.query.id})
            }
        },
        //点击指定页码跳转
        handleCurrentChange(page){
            this.robotlog.num=page;
            this.searchRobotlog();
        },
        clearParams(){
          this.robotlog.robotNo='';
          this.robotlog.createTimeStr='';
        },
        //查询日志
        searchRobotlog(){
            var zF = /[`~!@#$%^&*()_\+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）\+={}|《》？：“”【】、；‘'，。、]/
            if(zF.test(this.robotlog.robotNo)){
                return this.$message.error("请输入非特殊字符!");
            }
            if(this.$route.query.robotNo==undefined){
                return this.$message.error("参数异常!");
            }
            this.robotlog.robotNo=this.$route.query.robotNo;
            this.$http.post('/robotLog/selectRobotLog',JSON.stringify(this.robotlog))
            .then(response => {
                    if (response.data.code === 200) {
                       this.robotlogList=response.data.result.data;
                       this.total=response.data.result.total;
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {

            })
        },
      
  }
  
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.ell-input {
    width: 200px;
}
.m-l-30 {
  margin-left: 30px !important;
}

.el-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}
.map {
        width: 100%;
        height: 400px;
}
.el-table{
    font-size: 10px;
    height:'20px';
    padding:'0px'
}
 
</style>


// WEBPACK FOOTER //
// src/components/robot/Robotlog.vue